import React, { useState, useMemo, useEffect, useContext } from 'react'
import { Modal } from 'react-bootstrap'
import { AiFillEdit } from 'react-icons/ai'
import { MdSlideshow } from 'react-icons/md'

import api from '../../services/api'
import StoreContext from '../storage/context'
import TableCard from '../tableCard/index.js'
import errorHandler from '../errorHandler/index.js'
import NavigationBar from '../navigationBar/index.js'
import AlertCustom from '../alertCustom/index.js'
import ManualFileForm from '../manualFileForm/index.js'
import errorHandlerShow from '../errorHandlerShow/index.js'

import './styles.css'

// define a pagina de pesquisa dos cadastro arquivos manuais
const ManualFileSearch = () => {
	const { pk_user, givenName, pk_service, token, setToken } = useContext(StoreContext);

	const navegation = [
		{
			'nome': 'home',
			'link': '/'
		},
		{
			'nome': 'cadastro arquivos manuais',
			'link': `/cadastro-arq-manual?service_id=${pk_service}`
		},
		{
			'nome': 'consultar',
			'link': '/cadastro-arq-manual/consultar'
		}
	]

	const [lgShow, setLgShow] = useState(false);
	const [metadata, setMetadata] = useState([]);
	const [readOnly, setReadOnly] = useState(true);

	// state for display alert to users
	const [alert, setAlert] = useState({ header: '', message: '', type: '', options_btn: [] });
	const [showAlert, setShowAlert] = useState(false);

	// variables used for save manual file
	const [fields, setFields] = useState([])
	const [data, setData] = useState({
		is_project: '',
		justification_ingestion: '',
		project_name: '',
		requesting_area: '',
		requesting_company: '',
		requesting_email: '',
		requesting_name: '',

		area_for_business_data: '',
		company: '',
		domain_data: '',
		public_data: '',
		subject_data: '',
		responsible_for_business_data: '',

		maximum_data_history_time: '',
		maximum_data_history_time_unit: '',
		delimiter: '',
		desc_entity: '',
		entity_name: '',
		extension_file: '',
		frequency: '',
		type_load: '',
		pattern_file: "{entity_name}_{pattern_date}",

		// campo com valores fixos
		source_type: 'arquivos manuais',
		source_name: 'arquivos manuais',
		given_name: givenName,
		pk_user: pk_user,

		// fields to save in dynamo entity
		system_name: 'arquivos_manuais',
		account_destination: 'coe',
		datalake_destination: 'trusted',
		chunk_size: "256000000",
		pattern_date: '%Y%m%d',
		source_path: '{entity_name}',
		active: true,
		header: true,
		version: 0,
		name_responsible_validation: '',
		email_responsible_validation: '',
		validation_date: '',
		validation_status: '',
		desc_validation: '',

		// campos que não serão usados p/ arquivos manuais
		responsible_for_technical_data: '',
		area_for_technical_data: '',
		target_location: '',
		source_external: '',
		business_rules: '',
		related_entity: '',
		data_filter_source: '',
		primary_key_reuse: '',
		record_deletion_allowed: '',
		pattern_data: ''
	})

	useEffect(() => {
		api.get('manual-file/metadata', {
			params: { 'pk_user': pk_user },
			headers: { 'Authorization': token }
		}).then(response => {
			setMetadata(response.data.control_metadata)
		})
			.catch(error => {
				errorHandlerShow(error, setToken, setAlert, setShowAlert)
			})
	}, []);

	let data_2 = useMemo(() => metadata.map((item, index) => (
		{
			id: item.metadata.pk_metadata,
			version: item.control.version,
			fileName: item.metadata.entity_name,
			obs: item.control.desc_validation,
			status: item.control.validation_status,
			authorizers: item.metadata.email_notification_account.split(";").concat(item.metadata.fk_user)
		}
	)))

	const handleClickGroup = (values, action) => {
		setLgShow(true)

		if (action === 'view') {
			setReadOnly(true)
		} else {
			setReadOnly(false)
		}

		api.get('manual-file/metadata', {
			params: { 'pk_metadata': values.id, 'pk_user': pk_user },
			headers: { 'Authorization': token }
		})
			.then(response => {
				const res = response.data
				setData({ ...data, ...res.metadata, ...res.control })
				console.log(response.data)
				if (res.entity) {
					setFields(res.entity.fields)
				} else {
					setAlert({
						header: 'Algo deu errado com sua solicitação.',
						message: "Não foi possível recuperar algumas informações do arquivo. \n Por gentileza, tente novamente mais tarde, caso o erro persista entre em contato com administrador do portal.",
						type: 'danger',
						options_btn: []
					})
					// show alert with mensage
					setLgShow(false)
					setShowAlert(true)
					setFields([])
				}
			})
			.catch(error => {
				errorHandlerShow(error, setToken, setAlert, setShowAlert)
			})
	}

	const columns = useMemo(
		() => [
			{
				Header: '#',
				accessor: 'id', // accessor is the "key" in the data
			},
			{
				Header: 'Versão',
				accessor: 'version',
			},
			{
				Header: 'Nome do arquivo',
				accessor: 'fileName',
			},
			{
				Header: 'Observações da validação',
				accessor: 'obs',
			},
			{
				Header: 'Status da validação',
				accessor: 'status'
			},
			{
				width: 100,
				Header: "Ações",
				Cell: ({ value, column, row }) => (
					<div className='mf-search-actions'>
						<MdSlideshow size={20} onClick={() => handleClickGroup(row.original, 'view')} />
						{row.original.authorizers.includes(pk_user) ?
							<AiFillEdit size={20} onClick={() => handleClickGroup(row.original, 'edit')} />
							: null}
					</div>
				)
			}
		],
		[]
	)


	return (
		<div className="mf-search-container">
			{/* BARRA DE NAVEGAÇÃO */}
			<NavigationBar navegation={navegation} />

			{/* ALERT CUSTOM */}
			<AlertCustom showAlert={showAlert} setShowAlert={setShowAlert} alert={alert} />

			<TableCard data={data_2} columns={columns} />

			{/* formulario com dados do solicitante e governança */}
			<Modal
				dialogClassName="mfs-main-modal"
				// fullscreen={true}
				show={lgShow}
				onHide={() => { setLgShow(false); setData({}) }}
				aria-labelledby="example-modal-sizes-title-lg"
			>
				<Modal.Header closeButton>
					<Modal.Title id="example-modal-sizes-title-lg">
						Informações sobre o arquivo manual
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>

					{/* FORMS */}
					<ManualFileForm
						showAlert={showAlert}
						setShowAlert={setShowAlert}
						setAlert={setAlert}
						action={"EditAndShow"}
						readOnly={readOnly}
						fields={fields}
						setFields={setFields}
						data={data}
						setData={setData}
						setLgShow={setLgShow} />

				</Modal.Body>
			</Modal>
		</div>
	);
}

export default ManualFileSearch;